module.exports = __webpack_public_path__ + "img/feedbucket.5c9f99ac.jpg";